import { render, staticRenderFns } from "./StaffIndividualAwayAssignmentPage.vue?vue&type=template&id=60e1997b&scoped=true&"
import script from "./StaffIndividualAwayAssignmentPage.vue?vue&type=script&lang=js&"
export * from "./StaffIndividualAwayAssignmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e1997b",
  null
  
)

export default component.exports